export enum ProviderEnum {
  PARFUMART = 'parfumart',
  CDEK = 'cdek',
  X5 = 'x5',
  YATAXI = 'yataxi'
  // RUPOST = 'rupost'
}

export const localizedProviders = {
  [ProviderEnum.PARFUMART]: 'Parfumart',
  [ProviderEnum.CDEK]: 'СДЭК',
  [ProviderEnum.X5]: '5Post',
  [ProviderEnum.YATAXI]: 'Яндекс Доставка'
  // [ProviderEnum.RUPOST]: 'Почта России'
};

export enum WayToGetEnum {
  DELIVERY = 'delivery',
  PICKUP = 'pickup'
}

export const localizedWayToGet = {
  [WayToGetEnum.DELIVERY]: 'Курьером',
  [WayToGetEnum.PICKUP]: 'Самовывоз'
};
